export const presets = [50, 100, 200, 500]
